import React from 'react';
import { createRoot } from 'react-dom/client';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import App from './App';
import { registerSW } from 'virtual:pwa-register';

// Create Emotion cache
const emotionCache = createCache({
  key: 'css',
  stylisPlugins: [],
});

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <CacheProvider value={emotionCache}>
        <App />
      </CacheProvider>
    </React.StrictMode>
  );
}

// Register service worker with auto update
registerSW({
  onNeedRefresh() {
    console.log('New content available. Prompting for refresh...');
    if (confirm('¡Nuevo contenido disponible! ¿Deseas recargar la aplicación?')) {
      window.location.reload();
    }
  },
  onOfflineReady() {
    console.log('App ready to work offline');
    console.log('La aplicación está lista para funcionar sin conexión');
  },
  onRegisterError(error) {
    console.error('Error during service worker registration:', error);
  },
});
